import { Component, Input } from '@angular/core';
import { TeamServiceProvider } from '../../providers/team-service/team-service';
import { AlertController, NavController, Tabs } from 'ionic-angular';
import { CoffeShopPage } from '../../pages/coffe-shop/coffe-shop';
import { ShopNewPage } from '../../pages/shop-new/shop-new';
import { HttpClient } from '@angular/common/http';
import { ApiErrorHandlerProvider } from '../../providers/api-error-handler/api-error-handler';

/**
 * Generated class for the ShopGridComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'shop-grid',
  templateUrl: 'shop-grid.html'
})
export class ShopGridComponent {
  @Input() shops: any;
  errors: {};
  loading: boolean;

  constructor(public teamProvider: TeamServiceProvider,
    public alertCtrl: AlertController,
    private http: HttpClient,
    private apiErrorHandler: ApiErrorHandlerProvider,
    public navCtrl: NavController) { }

  ngOnInit() {
    if (this.shops) {
      this.shops.forEach((shop: any) => {
        shop.profile_data = null;
        if (shop.users) {
          shop.users.forEach((user: any) => {
            if (user.profile_data && typeof (user.profile_data) == "string") {
              user.profile_data = JSON.parse(user.profile_data);
              if (user.profile_data && user.profile_data.image_url && typeof (user.profile_data.image_url) == "string") {
                user.profile_data.image_url = JSON.parse(user.profile_data.image_url);
              }
              shop.profile_data = user.profile_data;
              return;
            } else {
              shop.profile_data = user.profile_data;
              return;
            }
          });
        }
      });
    }

  }

  shouldShowDistance(shop) {
    if (shop.hasOwnProperty('distance')) {
      return true;
    } else {
      return false;
    }
  }

  openPage(shop: any) {
    console.log({shop});
    
    this.navCtrl.push(ShopNewPage, { shop: shop });
  }


    getTuid() {
      return localStorage.getItem('tuid');
    }
  
    onWhitelistClick(event: MouseEvent, shop: any): void {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      let tuid = this.getTuid();
      shop.is_favourite = !shop.is_favourite;
      if (!tuid) {
        let tabBar: Tabs = this.navCtrl.parent;
        tabBar.select(4);
        return;
      }
  
      this.updateTrendingCutFavourite(shop, tuid)
    }
  
    updateTrendingCutFavourite(shop, tuid) {
      return new Promise((resolve, reject) => {
        this.http
          .put(`/favourite/user/${tuid}/shop/${shop.id}`,
            {
              user: tuid,
              teamTrendingCut: shop.id,
            },
          )
          .subscribe(
            (favouriteShop: Array<any>) => {
              resolve(favouriteShop);
            },
            (error) => {
              this.errors = this.apiErrorHandler.handleError(error);
            },
          );
      });
    }

}



// WEBPACK FOOTER //
// ./src/components/shop-grid/shop-grid.ts